// sessionAPI provides authentication and user session related API calls
import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type {
  AuthTokenData,
  CommonServicePayload,
  RefreshTokenData,
  UserValidation,
} from '../types/session.types';

const sessionAPI = {
  // Initiates sign-in flow and redirects to SSO login page
  signIn: async () => {
    const redirectURL = await axios.get(
      `${import.meta.env.VITE_APP_AUTH_URL}/signin`,
      {
        params: {
          authority: 'cognito',
          identity_provider: 'Yara-Active-Directory',
          version: 'v2',
        },
        headers: {
          callback: import.meta.env.VITE_APP_URL,
        },
      }
    );
    if (!redirectURL.data.redirectTo) {
      throw new Error(`Couldn't retrieve the redirect URL`);
    }
    window.location.href = redirectURL.data.redirectTo;
  },
  // Exchanges authorization code for authentication tokens
  getAuthToken: (code: string): Promise<AxiosResponse<AuthTokenData>> =>
    axios.get(`${import.meta.env.VITE_APP_AUTH_URL}/token`, {
      params: {
        code,
        authority: 'cognito',
        version: 'v2',
        app_id: 'STM',
        deploymentInfo: null,
      },
      headers: {
        callback: import.meta.env.VITE_APP_URL,
      },
    }),
  // Refreshes access token using a refresh token
  refreshAccessToken: async (
    refreshToken: string
  ): Promise<AxiosResponse<RefreshTokenData>> =>
    axios.get(`${import.meta.env.VITE_APP_AUTH_URL}/refresh_token`, {
      params: {
        refresh_token: refreshToken,
        authority: 'cognito',
        version: 'v2',
      },
      headers: {
        callback: import.meta.env.VITE_APP_URL,
      },
    }),
  // Validates access token and retrieves user profile
  getUserProfile: async (
    commonServicePayload: CommonServicePayload
  ): Promise<AxiosResponse<UserValidation>> =>
    axios.post(
      `${import.meta.env.VITE_APP_AUTH_URL}/validate_access`,
      commonServicePayload,
      {
        headers: {
          Authorization: commonServicePayload.token,
        },
      }
    ),
};

export default sessionAPI;
